<template>
  <span class="text-barlow-condensed subtitle d-flex legend-container">
    <div class="correct"></div>
    <span class="mx-2">Correctas</span>
    <div class="incorrect"></div>
    <span class="mx-2">Incorrectas</span>
    <div class="notAnswer"></div>
    <span class="mx-2"> No contestadas</span>
  </span>
</template>

<script>
export default {
  name: "Legend",
};
</script>

<style lang="scss" scoped>
.legend-container div {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.correct {
  background: var(--color-secondary);
}

.incorrect {
  background: var(--color-blue);
}

.notAnswer {
  background: var(--color-primary);
}
</style>
